import React, {useState, useMemo} from 'react';
import _ from 'lodash';
import {useSnackbar} from 'notistack';
import {Container, MenuItem, Select, Stack, Typography} from '@mui/material';
import {useQuery} from '@tanstack/react-query';
import {useBusyCallback, useOnce, useQueryParam} from '../util/react_hooks.js';
import api from '../util/api.js';
import SCTextField from './SCTextField.js';
import ConsentCheckbox from './ConsentCheckbox.js';
import SCButton from './SCButton.js';

export const ProductPurchaseForm = React.forwardRef((props, ref)=>{
    let {
        productId,
        btnText='מעבר לתשלום',
        title,
        noOutline,
        maxWidth='400px',
    } = props;
    let [consent, setConsent] = useState(false);
    let [firstName, setFirstName] = useState('');
    let [lastName, setLastName] = useState('');
    let [email, setEmail] = useState('');
    let [phone, setPhone] = useState('');
    let [qsFirstName] = useQueryParam('firstName');
    let [qsLastName] = useQueryParam('lastName');
    let [qsEmail] = useQueryParam('email');
    let [qsPhone] = useQueryParam('phone');
    useOnce(()=>setFirstName(qsFirstName), !!qsFirstName);
    useOnce(()=>setLastName(qsLastName), !!qsLastName);
    useOnce(()=>setEmail(qsEmail), !!qsEmail);
    useOnce(()=>setPhone(qsPhone), !!qsPhone);
    let {enqueueSnackbar} = useSnackbar();
    let [proceed, proceeding] = useBusyCallback(async ()=>{
        try {
            let res = await api.product.createPaypage(
                {productId, firstName, lastName, email, country: 'IL', phone, consent});
            window.location.href = res.paypage;
        } catch (e) {
            let errmsg = 'אירעה שגיאה, נסו שוב מאוחר יותר';
            if (e.code=='validation_error')
                errmsg = e.extra.map(c=>c.message).join('. ');
            else if (e.code&&e.message)
                errmsg = e.message;
            else
                console.error(e);
            enqueueSnackbar(errmsg, {variant: 'error'});
        }
    }, [enqueueSnackbar, productId, firstName, lastName, email, phone, consent]);
    return <Container maxWidth="md" ref={ref} sx={{padding: 0}}>
      <Stack justifyContent="center" alignItems="center">
        <Stack maxWidth={maxWidth} gap={2} sx={{
            textAlign: 'right',
            // backgroundColor: '#FFF7EE',
            ...!noOutline&&{
                padding: 3,
                borderRadius: '4px',
                border: '1px solid #cccccc',
            },
        }}>
          {title&&<Typography variant="h4">{title}</Typography>}
          <SCTextField required label="שם פרטי" value={firstName} onChange={setFirstName}/>
          <SCTextField required label="שם משפחה" value={lastName} onChange={setLastName}/>
          <SCTextField required label={'דוא"ל'} value={email} onChange={setEmail}/>
          <SCTextField required label="טלפון" value={phone} onChange={setPhone}
            placeholder="לדוגמה: 0501234567"/>
          <Stack direction="column" gap={1} sx={{width: '100%'}}>
            <Typography color="text.secondary">מדינה</Typography>
            <Select value="IL">
              <MenuItem value="IL">ישראל</MenuItem>
            </Select>
          </Stack>
          <ConsentCheckbox value={consent} onChange={setConsent}/>
          <SCButton text={btnText} variant="contained" onClick={proceed} loading={proceeding}
            sx={{px: 4, py: 1.8, fontSize: 20}}/>
        </Stack>
      </Stack>
    </Container>;
});
